{
  "nl": {
    "datatable": {
      "actions": {
        "bulk_action": "Actie in bulk",
        "bulk_edit": "Bewerk in bulk",
        "clear_filters": "Filters wissen",
        "deselect_all": "Alles deselecteren",
        "select_all": "Alles selecteren"
      },
      "labels": {
        "gridlines": "Rasterlijnen",
        "size": "Grootte",
        "toggle_columns": "Kolommen wisselen"
      }
    }
  }
}